import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=b68e6bbe&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b68e6bbe')) {
      api.createRecord('b68e6bbe', component.options)
    } else {
      api.reload('b68e6bbe', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=b68e6bbe&", function () {
      api.rerender('b68e6bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GzPYln3VwOYm/JS/imageCarousel.vue"
export default component.exports